import type { CountryLocalizations, TextLocalization } from '../types';

export const englishLocalization: TextLocalization = {
  inputPlaceholder: 'Phone number',
  inputInputLabel: 'Add your number to pay with {marketBrandName}',
  inputPrimaryLabel: 'Continue to pay with {marketBrandName}',
  useSavedNumberButton: 'Use my saved {marketBrandName} number',
  continueAsLabel: 'Continue as {0}',
  useAnotherNumberLabel: 'Use another number',
  rememberMeLabel: 'Remember my number',
  inputPrimary: 'Next',
  inputCancel: 'Cancel the payment',
  inputCancelLabel: 'Cancel payment and return to the webshop',
  logoTitle: '{marketBrandName} logo',
  localeSelectorLabel: 'Language options, {0} selected',
  countryCodeSelectorLabel: 'Select country, {0} selected',
  statusHeader: 'Open {marketBrandName}',
  statusAriaLabel:
    'You have {0} minutes and {1} seconds to open {marketBrandName} and complete the payment.',
  statusContent: "We've sent a payment request to {0}",
  errorHeader: 'Whoops, something went wrong',
  errorContent: 'Please try again.',
  errorPrimary: 'Go back',
  timeoutHeader: 'Oh no, your payment timed out',
  timeoutContent: 'Go back and try again.',
  timeoutPrimary: 'Go back',
  scanToOpenInKlarna: 'Scan to add Klarna to {marketBrandName}',
  addKlarna: 'Add Klarna to {marketBrandName}',
  openVipps: 'Open {marketBrandName}',
  openInKlarnaMobileText: 'On a phone? Tap here',
  inputCountryCodeLabel: 'Country code',
  inputError: 'You need {marketBrandName} installed on your phone and be 15 or older.',
  inputErrorNoEdit: 'This business requires you to use the mobile number used in your profile.',
  statusNumberFallback: 'your number.',
  dropDownOptionsLabel: 'Options',
  qrAltTag: 'QR-code for payment',
  qrSeparator: 'or use your phone number',
  upgradeApp: 'Seeing this text? Upgrade your app.',
  cookieDeclarationText:
    'We use only necessary cookies required for the proper functioning of our website.',
  cookieDeclarationLink: 'Read more in our {cookieDeclaration}.',
  cookieDeclaration: 'cookie declaration',
  scanToPay: 'Scan to pay',
  paymentTo: 'to',
  skipToContent: 'Skip to content',
  inputHeadingAmount: 'Pay {0} to {1}',
  inputHeadingRecurring: 'Pay to {0}',
  inputDescription: 'Type in your phone number and complete the payment in {marketBrandName}.',
  inputDescriptionQr: 'Scan the QR and complete the payment in {marketBrandName}.',
};

export const englishCountryLocalization: CountryLocalizations = {
  britain: {
    country: '',
    language: 'English',
  },
  denmark: {
    country: 'Denmark',
    language: 'Danish',
  },
  finland: {
    country: 'Finland',
    language: 'Finnish',
  },
  norway: {
    country: 'Norway',
    language: 'Norwegian',
  },
  sweden: {
    country: 'Sweden',
    language: 'Swedish',
  },
  greenland: {
    country: 'Greenland',
    language: 'Engelsk',
  },
};
